/**
 * BuildCheckboxList — parallel to CheckboxList (shop filters) for the
 * /build filter drawer. Same dark-walnut styling.
 */
interface Option {
  readonly id: string
  readonly label: string
  readonly subLabel?: string | number
}

interface Props {
  readonly options: ReadonlyArray<Option>
  readonly selectedIds: ReadonlySet<string>
  readonly onToggle: (id: string) => void
  readonly maxHeightClass?: string
  readonly emptyNote?: string
}

export function BuildCheckboxList({
  options,
  selectedIds,
  onToggle,
  maxHeightClass = 'max-h-56',
  emptyNote = 'No options.'
}: Props): JSX.Element {
  if (options.length === 0) {
    return (
      <p className="font-body text-body-xs text-text-light/70">{emptyNote}</p>
    )
  }
  return (
    <div className={`${maxHeightClass} overflow-y-auto rounded-md border border-text-light/15 bg-text-light/5 px-2 py-1`}>
      <ul className="space-y-0.5">
        {options.map((opt) => {
          const checked = selectedIds.has(opt.id)
          return (
            <li key={opt.id}>
              <label className="flex cursor-pointer items-center justify-between gap-2 rounded px-2 py-1 transition hover:bg-text-light/10">
                <span className="flex min-w-0 items-center gap-2">
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => onToggle(opt.id)}
                    className="h-4 w-4 flex-shrink-0 accent-forest"
                  />
                  <span className="truncate font-body text-body-sm text-text-light">{opt.label}</span>
                </span>
                {opt.subLabel !== undefined ? (
                  <span className="flex-shrink-0 font-mono text-body-xs text-text-light/60">
                    {opt.subLabel}
                  </span>
                ) : null}
              </label>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
